import React from "react";
import { useHistory } from "react-router-dom";

// Os dois planos e os botões de pré-pago e WhatsApp da página inicial nova.
// Ficam num lugar só para a /tv mostrar sempre os mesmos preços da página inicial
// (a /tv de 03/10 usava os planos da página antiga, que estavam desatualizados).
export default function PlanosCartoes() {
  const history = useHistory();
  const go = (to) => history.push(`/${to}`);

  return (
    <>
      <div className="plans">
        <div className="plan">
          <h3>Plano Mensal</h3>
          <div className="price">R$ 22,90<small>/mês</small></div>
          <div className="eq">flexível, cancele quando quiser</div>
          <ul>
            <li>Acesso ilimitado aos conteúdos</li>
            <li>Até 3 crianças ao mesmo tempo</li>
            <li>Cancele a qualquer momento</li>
            <li>Atividades no site para imprimir</li>
            <li>Livro digital animado para leitura</li>
          </ul>
          <button className="btn btn-secondary" onClick={() => go("register")}>Quero o mensal</button>
        </div>
        <div className="plan best">
          <div className="badge">★ ECONOMIZE R$ 81,60/ano</div>
          <h3>Plano Anual</h3>
          <div className="price">R$ 14,90<small>/mês</small></div>
          <div className="eq">R$ 178,80 à vista no ano</div>
          <ul>
            <li>Tudo do plano mensal</li>
            <li>Acesso ilimitado aos conteúdos</li>
            <li>Até 3 crianças ao mesmo tempo</li>
            <li>Atividades no site para imprimir</li>
            <li>Livro digital animado para leitura</li>
          </ul>
          <button className="btn btn-green" onClick={() => go("register")}>Quero Assinar</button>
        </div>
      </div>
      <div className="cta-botoes">
        <a className="btn btn-roxo" href="https://www.joinkids.com.br/register?provider=giftcard">Cartão Pré-pago</a>
        <a className="btn btn-ghost" style={{ color: "var(--primary)", borderColor: "var(--primary)" }} href="https://wa.me/5592982168732?text=Eu%20quero%20saber%20mais!" target="_blank" rel="noopener noreferrer">Falar no WhatsApp</a>
      </div>
    </>
  );
}
